import { Button } from "common/components/ui/Button";
import { DialogFooter, DialogHeader } from "common/components/ui/Dialog";
import { DrawerFooter, DrawerHeader } from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import useAudienceMutations from "../../../datahooks/useAudienceMutations";

import type { AudienceFilters, AudienceProfile } from "../../../types";

interface RemoveTargetsProps {
  selectedTargets: AudienceProfile[];
  onBack: () => void;
  onSuccess: () => void;
  filters?: AudienceFilters;
}

export default function RemoveTargets({
  selectedTargets,
  onBack,
  onSuccess,
  filters,
}: RemoveTargetsProps) {
  const isDesktop = useTwBreakpoint("lg");

  const Footer = isDesktop ? DialogFooter : DrawerFooter;

  const Header = isDesktop ? DialogHeader : DrawerHeader;
  const { removeProfiles, isRemovingProfiles } = useAudienceMutations(filters);

  const eligibleProfiles = selectedTargets.filter(
    ({ state }) => state !== "done" && state !== "cancelled",
  );
  const suffix = eligibleProfiles.length > 1 ? "s" : "";
  const title = "Remove targets?";
  const description = `Are you sure you want to remove ${eligibleProfiles.length} target${suffix} from this campaign?`;

  function onRemove() {
    removeProfiles({
      targetUrns: eligibleProfiles.map(({ urn }) => urn),
    }).then(onSuccess);
  }

  return (
    <>
      <Header title={title} subtitle={description} onBack={onBack} />

      <Footer className="justify-end">
        <Button
          variant="secondary-black"
          onClick={onBack}
          disabled={isRemovingProfiles}
        >
          Cancel
        </Button>

        <Button
          variant="outline-danger"
          onClick={onRemove}
          isLoading={isRemovingProfiles}
        >
          Remove
        </Button>
      </Footer>
    </>
  );
}
